<template>
  <div class="wrapper_dark">
    <div class="header">
      <h1 class="title">관리자 로그인</h1>
    </div>
    <div class="inner_wrap">
      <div class="privacy_input_wrap">
        <div>
          <input class="privacy_name" type="text" :placeholder="'이메일을 입력해주세요.'" v-model="email" />
          <input
            class="privacy_num"
            type="password"
            :placeholder="'비밀번호를 입력해주세요.'"
            v-model="password"
          />
        </div>
        <div class="next_btn_wrap">
          <!--  -->
          <button class="next_btn" :class="{ active: isActive }" @click="login">로그인</button>
        </div>
      </div>
      <div class="privacy_notice">
        <h3 class="privacy_notice_title">매장계정(이메일)을 확인해주세요.</h3>
        <ol class="notice_content">
          <li>매장 계약시 발급받은 아이디를 확인해주세요.</li>
          <li>계정 문의는 본사로 연락부탁드립니다. Tel. 1899-9195</li>
        </ol>
        <span class="footer_version">ver.{{ version }}</span>
      </div>
    </div>
    <RestaurantSelectPopup :restaurantList="userRestaurantList" v-show="showPopup" />
  </div>
</template>

<script>
import packageFile from '../../package.json'
import { getUserRestaurantsList } from '@/api/login'
import axios from 'axios'
import RestaurantSelectPopup from '@/components/RestaurantSelectPopup.vue'
import { renewalOtpNumber } from '../utills'
import { isValidEmail } from '@/shared/validation/login'

export default {
  name: 'LoginView',
  components: {
    RestaurantSelectPopup
  },
  data () {
    return {
      email: '',
      password: '',
      isActive: true,
      showPopup: false,
      userRestaurantList: []
    }
  },
  computed: {
    version () {
      return packageFile.version
    }
  },
  methods: {
    login () {
      // TB-7894: 앞뒤 공백 제거 후 기본 이메일 양식 검증
      const email = this.email.trim()
      this.email = email
      if (!isValidEmail(email)) {
        alert('이메일 형식이 올바르지 않습니다.')
        return
      }
      const loginParam = {
        email,
        password: this.password
      }
      // 계정정보를 받아서 로그인 후 사용자 매장목록 호출
      axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/v1/login`, loginParam)
        .then(async res => {
          const { accessToken, refreshToken } = res.data
          this.$store.commit('setAccessToken', `Bearer ${accessToken}`)
          this.$store.commit('setRefreshToken', refreshToken)
          const { data } = await getUserRestaurantsList()
          this.userRestaurantList = data
          if (this.userRestaurantList.length > 1) {
            this.openRestaurantSelectPop()
          } else {
            this.$store.commit('setStoreIdx', this.userRestaurantList[0].idx)
            this.$store.dispatch('setRestaurant', this.userRestaurantList[0].idx).then(() => {
              renewalOtpNumber()
              this.$router.push('/')
            }).catch((err) => {
              console.error(err)
            })
          }
        })
        .catch((e) => {
          const error = e.response.data.error
          alert(error.message)
        })
    },
    openRestaurantSelectPop () {
      this.showPopup = true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";

.inner_wrap {
  // display: block;
  // padding-top: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @include flex-gap(5vh, column);
  background: $gray_50;
  .privacy_input_wrap {
    display: flex;
    // margin-bottom: 46px;
    justify-content: center;
    input {
      display: block;
      font-size: 30px;
      width: 880px;
      height: 57px;
      padding: 0 15px;
      border-radius: 3px;
      border: 1px solid $gray_400;
      &::placeholder {
        color: rgba(48, 48, 48, 0.5);
      }
    }
    .privacy_name {
      margin-bottom: 30px;
    }
  }

  .next_btn_wrap {
    padding-left: 30px;
    .next_btn {
      width: 250px;
      height: 144px;
      border-radius: 3px;
      border: 0;
      background: $cancle_gray;
      color: $white;
      font-size: 30px;

      &.active {
        background: $light_blue;
      }
    }
  }
  .privacy_notice {
    position: relative;
    height: 420px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 3px;
    background: $information;
    color: $white;
    font-size: 27px;
    .privacy_notice_title {
      color: $check;
      padding-bottom: 30px;
    }
    .notice_content {
      line-height: 1.5;
      li {
        color: $white;
      }
    }
    .footer_version {
      position: absolute;
      bottom: 10px;
      right: 10px;
      font-weight: normal;
      font-size: 18px;
    }
  }
}
</style>
